import { useTranslation } from "react-i18next";

import { SUPPORT_WHATSAPP_NUMBER } from "../../setup/constants";
import styles from "./styles.module.scss";
import { ClockIcon, ReviewDocIcon } from "./gateIcons";
import OrganizationReviewCard from "./OrganizationReviewCard";

/** A document row on the pending screen, with its label already resolved. */
export interface IReviewDocument {
  key: string;
  title: string;
  fileName?: string;
}

interface Props {
  /**
   * Documents on file, listed back as confirmation. Sourced either from this session's upload
   * or from the attachments endpoint on a later visit.
   */
  documents?: IReviewDocument[];
}

const OrganizationPending: React.FC<Props> = ({ documents }) => {
  const { t } = useTranslation();

  return (
    <OrganizationReviewCard
      variant="pending"
      title={t("lbl_org_pending_title")}
      description={t("lbl_org_pending_subtitle")}>
      {!!documents?.length && (
        <div className={styles.docsReadOnly}>
          {documents.map(({ key, title, fileName }) => (
            <div className={styles.dcRow} key={key}>
              <span className={styles.dcIcon}>
                <ReviewDocIcon />
              </span>
              <span className={styles.dcTxt}>
                <b>{title}</b>
                {fileName && (
                  <span className={styles.dcFile} dir="auto">
                    {fileName}
                  </span>
                )}
              </span>
              <span className={styles.dcChip}>
                {t("lbl_org_docs_review_chip")}
              </span>
            </div>
          ))}
        </div>
      )}
      <div className={styles.reviewSep} />
      <div className={styles.reviewFoot}>
        <ClockIcon />
        {t("lbl_org_pending_duration")}
        {SUPPORT_WHATSAPP_NUMBER && (
          <>
            <span className={styles.dotSep}>·</span>
            <a
              className={styles.reviewFootLink}
              href={`https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noreferrer">
              {t("lbl_customer_service")}
            </a>
          </>
        )}
      </div>
    </OrganizationReviewCard>
  );
};

export default OrganizationPending;
